import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'

export const GetSampleMetaDataEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.getSampleMetaDatasRequest.match),
    mergeMap((action) =>
      OrderRepository.getSampleMetaDatas(action.payload.orderId).pipe(
        mergeMap((response) => of(order.getSampleMetaDatasSuccess(response))),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.getSampleMetaDatasFailure({ error }))
          })
        )
      )
    )
  )
